import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/partsApi';
import * as types from '../constants/partsConstants';

export const getPartsActions = (search, unpaged) => async (dispatch) => {
  dispatch({ type: types.GET_PARTS_REQUEST });
  try {
    const { error, data } = await api.getParts(search, unpaged);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_PARTS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список деталей');
    dispatch({ type: types.GET_PARTS_FAILURE });
  }
};

export const updatePartAction = (part) => async () => {
  try {
    const { error } = await api.updatePart(part);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити деталь');
  }
};

export const createPartAction = (part) => async () => {
  try {
    const { error } = await api.createPart(part);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати деталь');
  }
};

export const deletePartAction = (partId) => async () => {
  try {
    const { error } = await api.deletePart(partId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити деталь');
  }
};

export const clearPartsActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_PARTS,
  });
};

export const setPartsPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_PARTS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedPartAction = (part) => async (dispatch) => {
  dispatch({
    type: types.SELECT_PART,
    payload: part,
  });
};

export const clearSelectedPartAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_PART,
  });
};

export const setPartsSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_PARTS_SEARCH,
    payload: search,
  });
};

export const nextPartsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_PARTS_PAGE,
  });
};

export const prevPartsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_PARTS_PAGE,
  });
};
